export default {
  upgradePlan: {
    upTo: 'upgradePlan.upTo',
    upToSmall: 'upgradePlan.upToSmall',
    upToLowerCase: 'upgradePlan.upToLowerCase',
    cameras: 'upgradePlan.cameras',
    specialOffer: 'upgradePlan.specialOffer',
    month: 'upgradePlan.month',
    monthUppCase: 'upgradePlan.monthUppCase',
    monthShort: 'upgradePlan.monthShort',
    title: 'upgradePlan.mainTitle',
    subTitle: 'upgradePlan.mainSubTitle',
    hi: 'general.hi',
    freeTrial: 'upgradePlan.freeTrial',
    timeToMake: 'upgradePlan.timeToMake',
    needHelp: 'upgradePlan.needHelp',
    chooseThePlan: 'upgradePlan.chooseThePlan',
    single: 'upgradePlan.single',
    cameraLicence: 'upgradePlan.cameraLicence',
    annuallySave: 'upgradePlan.annuallySave',
    multipleSave: 'upgradePlan.multipleSave',
    orPay: 'upgradePlan.orPay',
    billedMonthly: 'upgradePlan.billedMonthly',
    billedMonthlyMultiple: 'upgradePlan.billedMonthlyMultiple',
    multiple: 'upgradePlan.multiple',
    cameraLicences: 'upgradePlan.cameraLicences',
    perCamera: 'upgradePlan.perCamera',
    perCameraShort: 'upgradePlan.perCameraShort',
    enterprise: 'upgradePlan.enterprise',
    PPC: 'plan.payPerClick',
    perAnalysis: 'upgradePlan.perAnalysis',
    allPricesInAUD: 'bottomMenu.allPricesInAUD',
    allPricesInUS: 'bottomMenu.allPricesInUS',
    allPricesInEUR: 'bottomMenu.allPricesInEUR',
    allPricesInGBP: 'bottomMenu.allPricesInGBP',
    termsText: 'bottomMenu.termsText',
    privatePolicy: 'bottomMenu.privatePolicy',
    and: 'bottomMenu.and',
    termsCondition: 'bottomMenu.termsCondition',
    youHaveSix: 'upgradePlan.youHaveSix',
    select: 'upgradePlan.select',
    FAQ: 'upgradePlan.FAQ',
    FAQ1Title: 'upgradePlan.FAQ1Title',
    FAQ1Desc: 'upgradePlan.FAQ1Desc',
    FAQ2Title: 'upgradePlan.FAQ2Title',
    FAQ2Desc: 'upgradePlan.FAQ2Desc',
    FAQ3Title: 'upgradePlan.FAQ3Title',
    FAQ3Desc: 'upgradePlan.FAQ3Desc',
    chat: 'upgradePlan.chat',
    getInTouch: 'upgradePlan.getInTouch',
    getInTouchButton: 'upgradePlan.getInTouchButton',
  },
};
